export const SCRUM = 'scrum' as const;
export const KANBAN = 'kanban' as const;
export const SIMPLE = 'simple' as const;
